import React, { useMemo, useState } from 'react';
import { Popover, Box, Typography, Stack, Button, Select, MenuItem, Divider } from '@mui/material';

export default function ShiftActionPopover({
  open,
  anchorEl,
  onClose,
  shift,
  employee,
  roles = [],
  onOpenShift, // () => void
  onPickEmployee, // (role) => void
}) {
  const [role, setRole] = useState(shift?.role || roles[0] || '');

  const duration = useMemo(() => {
    if (!shift) return 0;
    const s = new Date(String(shift.start_ts).replace(' ', 'T'));
    const e = new Date(String(shift.end_ts).replace(' ', 'T'));
    return Math.round(((e - s) / 3600000) * 10) / 10;
  }, [shift]);

  if (!shift) return null;

  const start = new Date(String(shift.start_ts).replace(' ', 'T'));
  const end = new Date(String(shift.end_ts).replace(' ', 'T'));
  const formatTime = (d) => d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

  return (
    <Popover open={open} anchorEl={anchorEl} onClose={onClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
      <Box sx={{ p: 1.5, minWidth: 300 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{employee ? `${employee.first_name} ${employee.last_name}` : 'Unassigned'}</Typography>
        <Typography variant="body2" color="text.secondary">
          {shift.role} • {formatTime(start)} – {formatTime(end)} • {duration}h
        </Typography>

        <Divider sx={{ my: 1 }} />

        <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
          <Button size="small" variant="contained" onClick={() => { onClose?.(); onOpenShift?.(); }}>Open Shift</Button>
          <Button size="small" variant="outlined" onClick={() => { onPickEmployee?.(shift.role); }}>Reassign (same role)</Button>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center">
          <Select size="small" value={role} onChange={(e)=>setRole(e.target.value)} sx={{ minWidth: 160 }}>
            {roles.map(r => (<MenuItem key={r} value={r}>{r}</MenuItem>))}
          </Select>
          <Button size="small" onClick={() => { onPickEmployee?.(role); }}>Reassign (choose role)</Button>
        </Stack>
      </Box>
    </Popover>
  );
}

